module.exports = __webpack_public_path__ + "static/nuclyalogo.7990b95d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nuclyalogo.jpg
// module id = 533
// module chunks = 117206707316740